import { Component } from '@angular/core';

@Component({
  selector: 'app-land-and-building-register-data-update-request',
  templateUrl:
    './land-and-building-register-data-update-request.component.html',
  standalone: false,
})
export class LandAndBuildingRegisterDataUpdateRequestComponent {}
